import { BigNumber } from '@frontend/numeric';

import { numberOrDefault } from '../number';

/** When truncate is true, the number will be truncated to the specified decimal place without rounding. */
export const kNumberFormatter = (
  value: number | undefined | null,
  decimal = 0,
  showDash = true,
  truncate = false,
  abs = false,
  currencySymbol?: string
) => {
  if (!Number.isFinite(value)) {
    return '--';
  }
  if (value === 0) {
    if (showDash) {
      return '--';
    }
    const zeroFormatted = parseFloat((0).toFixed(decimal)).toFixed(decimal);
    return currencySymbol ? `${currencySymbol}${zeroFormatted}` : zeroFormatted;
  }

  let bigNumber = new BigNumber(numberOrDefault(value));
  const decimalPlaces = numberOrDefault(decimal, 0);

  if (truncate) {
    const truncated = bigNumber.toFixed(decimalPlaces, BigNumber.ROUND_DOWN);
    bigNumber = BigNumber(truncated);
  }

  if (abs) {
    return bigNumber.abs().toFormat(decimalPlaces);
  }

  if (currencySymbol) {
    if (bigNumber.isNegative()) {
      return `-${currencySymbol}${bigNumber.abs().toFormat(decimalPlaces)}`;
    }
    return `${currencySymbol}${bigNumber.toFormat(decimalPlaces)}`;
  }

  return bigNumber.toFormat(decimalPlaces);
};
